<div class="mb-4">
    <div class="fs-5 fw-semibold">{{ business().Name }}</div>
    <div class="text-secondary">{{ business().Directors }}</div>
</div>
<h6 class="fw-bold text-secondary">Linked Accounts ({{ faList().length }})</h6>
<div class="acc-list">
@for (f of sortedFaList(); track f.Id; let i = $index) {
    <div class="list-item p-2 d-flex gap-2 align-items-center" [class.disabled-item]="f.Disabled">
        <img [src]="getBankLogoByName(f.Bank)" style="max-height: 48px; max-width: 48px" />
        <div class="flex-fill lh-sm">
            <div class="fw-semibold">{{ f.Description }}</div>
            <small class="text-secondary">
                <span class="fw-semibold">{{ f.Code }}</span>
                @if (f.AccNumber?.length > 0) { | {{ f.AccNumber }} }
                @if (f.Directors?.length > 0) { | {{ f.Directors }} }
            </small>
        </div>
        <i class="fas fa-unlink text-secondary pointer" (click)="unlinkFA(f)"></i>
    </div>
}
</div>
